
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Vizualizacije',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Unesite broj',
	'maxValuePlaceholder': 'Unesite broj',
	'customRangeErrorMessage': 'Vrijednost mora biti broj',
	'propFillColor': 'Boja za ispunu',
	'propBorderColor': 'Boja obruba',
	'propColorPalette': 'Trenutna paleta boja',
	'propColorPaletteChangeLabel': 'Promijeni paletu boja',
	'propNewColorPaletteLabel': 'Kreiraj prilagođenu paletu boje',
	'propNewHeatPaletteLabel': 'Kreiraj prilagođenu paletu topline',
	'propDonutRadius': 'Radijus prstena',
	'showTitleLabel': 'Pokaži naslov',
	'titleTypeLabel': 'Naslovni tip',
	'smartTitleLabel': 'Pametni tip',
	'customTitleLabel': 'Prilagođeni tip',
	'noTitleLabel': 'Nema naslova',
	'propHeatScalePalette': 'Trenutna paleta topline',
	'propHeatPaletteChangeLabel': 'Promijeni paletu topline',
	'propMaintainAxisScales': 'Zadrži skalu osi',
	'propLineAndSymbolColor': 'Boja linija i simbola',
	'propLineAndSymbolPalette': 'Paleta boja za linije i simbole',
	'propElementColor': 'Boja elementa',
	'propColumnColor': 'Boja stupca',
	'propColumnPalette': 'Paleta boja stupca',
	'propColumnHeatPalette': 'Paleta topline stupaca',
	'propBarColor': 'Boja trake',
	'propGoalColor': 'Boja cilja',
	'propToColor': 'U boju',
	'propFromColor': 'Iz boje',
	'propNumberValidationErrorMessageId': 'Unesite broj',
	'fontSizeAuto': 'Automatski',
	'propAutoBinCount': 'Broj grupa',
	'propAutoBinToggle': 'Auto-grupiranje',
	'tabName_general': 'Opće',
	'tabName_visDetails': 'Detalji',
	'tabName_animation': 'Animacija',
	'tabName_mediaDetails': 'Detalji medija',
	'tabName_webDetails': 'Detalji web stranice',
	'tabName_imageDetails': 'Detalji slike',
	'tabName_visualization': 'Vizualizacija',
	'tabName_text': 'Tekst',
	'sectionName_colorsAndThemes': 'Boja i teme',
	'sectionName_appearance': 'Izgled',
	'sectionName_general': 'Opće',
	'sectionName_colorPalette': 'Boja',
	'sectionName_axis': 'Os',
	'sectionName_axis_label': 'Os',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Grafikon',
	'sectionName_regionLayer': 'Sloj regija',
	'sectionName_pointLayer': 'Sloj točaka',
	'sectionName_latLongLayer': 'Sloj zemljopisne širine/dužine',
	'sectionName_pathLayer': 'Sloj staza',
	'sectionName_xAxis': 'X os',
	'sectionName_yAxis': 'Y os',
	'sectionName_xAxis_title': 'Naslov x osi',
	'sectionName_yAxis_title': 'Naslov y osi',
	'sectionName_xAxis_label': 'Oznaka x osi',
	'sectionName_yAxis_label': 'Oznaka y osi',
	'sectionName_column_yAxis': 'Y os stupca',
	'sectionName_column_yAxis_label': 'Oznaka y osi stupca',
	'sectionName_column_yAxis_title': 'Naslov y osi stupca',
	'sectionName_line_yAxis': 'y os linije',
	'sectionName_line_yAxis_label': 'Oznaka y osi linije',
	'sectionName_line_yAxis_title': 'Naslov y osi linije',
	'sectionName_title': 'Naslov',
	'sectionName_dataValueLabels': 'Oznake vrijednosti podataka',
	'sectionName_style': 'Stil',
	'propTransparencyDescription': 'Učini objekt više ili manje prozirnim. Upišite vrijednost između 0 i 100',
	'smart_annotation_unauthorized': 'Primjedbe: neovlašteni pristup',
	'smart_annotation_method': 'Primjedbe: metoda nije dozvoljena',
	'smart_annotation_media': 'Primjedbe: tip medija nije dozvoljen',
	'smart_annotation_input': 'Primjedbe: pogrešan ulaz',
	'smart_annotation_internal': 'Primjedbe: unutarnja sistemska greška',
	'smart_annotation_generic_error': 'Primjedbe: greška servisa',
	'smart_annotation_dialog_title': 'Uvid',
	'smart_annotation_Show_Insights': 'Pokaži uvide',
	'smart_annotation_Relationship': 'Odnos je',
	'forecast_enter_number': 'Unesite broj između ',
	'and': ' i ',
	'smart_errors': 'Greške primjedbi:',
	'smart_warnings': 'Upozorenja primjedbi:',
	'smart_annotation_insight_icon_title': 'Uvid',
	'smart_annotations_toggle_on': 'Uključi uvid',
	'smart_annotations_toggle_off': 'Isključi uvid',
	'smart_annotation_toggle_on': 'Uključi',
	'smart_annotation_toggle_off': 'Isključi',
	'smart_annotation_insight_unavailable': 'Uvidi trenutno nisu dostupni',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Uvidi nisu dostupni kad je primijenjen postotni filter gornjih ili donjih elemenata',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Predviđanje nije dostupno kad je primijenjen postotni filter gornjih ili donjih elemenata',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Uvidi nisu dostupni kad je primijenjen filter gornjih ili donja i postoji više od jednog stupca u polju',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Predviđanje nije dostupno kad je primijenjen filter gornjih ili donjih i postoji više od jednog stupca u polju',
	'forecast_title': 'Predviđanje',
	'forecast_show': 'Pokaži predviđanje',
	'forecast_toggle_on': 'Uključi predviđanje',
	'forecast_toggle_off': 'Isključi predviđanje',
	'statDetailsPerspectiveTitle': 'Analiza',
	'emptyStatDetailsPanel': 'Dodatne analize nisu dostupne za trenutnu vizualizaciju.',
	'predict_errors': 'Greške analize',
	'predict_warnings': 'Upozorenja analize',
	'fpd_invalid_data_source': 'Ovaj izvor podataka nema pridružen smarts modul',
	'fpd_network_issue': 'Došlo je do problema tijekom izvođenja analize na ovom izvoru podataka',
	'fpd_data_source_category': 'Smarts modul nedostaje',
	'fpd_response_errors': 'Greške preporučenog pogonitelja',
	'fpd_response_warnings': 'Upozorenja preporučenog pogonitelja',
	'catalyst_service_bad_request': 'Loš zahtjev',
	'catalyst_service_unkown_Id': 'Pronađen je ID nepoznatog zahtjeva',
	'catalyst_service_internal_server_error': 'Interna greška poslužitelja',
	'catalyst_service_generic_error': 'Greška servisa katalista',
	'catalyst_service_error': 'Ovaj servis trenutno nije dostupan',
	'propLegendPosition': 'Položaj legende',
	'propLeft': 'Lijevo',
	'propRight': 'Desno',
	'propTop': 'Vrh',
	'propBottom': 'Dno',
	'propNone': 'Nijedan',
	'propLegendDisplay': 'Prikaz legende',
	'targetThicknessPlaceHolder': '%{min} do %{max}',
	'targetThicknessErrorMsg': 'Unesite cijeli broj između %{min} i %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Pogonitelji (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'izabrani)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Resetiraj na defaulte',
	'possibelKeyDriver_AddNewDrivers': 'Dodaj još pogonitelja',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Pretraži radi dodavanja još pogonitelja',
	'possibleKeyDrivers_MaxPossibleReached': 'Poništite izbor nekih progonitelja radi dodavanja ili biranja drugih pogonitelja',
	'possibleKeyDrivers_Recommended': 'Preporučeno',
	'visRecommendedTypes': 'Preporučeni tipovi vizualizacije',
	'visRecommender_smartsfailure': 'preporuke za vizualizaciju trenutno nisu dostupne',
	'visMore': 'Više...',
	'visMoreTooltip': 'Više vizualizacija',
	'visOtherTypes': 'Ostali tipovi vizualizacije',
	'visChange': 'Promijeni vizualizaciju',
	'automaticTypeCaption': 'Automatski',
	'propVisType': 'Tipovi vizualizacije',
	'dlg_loading': 'Učitavanje...',
	'snippetListChartCaption': 'Lista komadića',
	'convoClusterChartCaption': 'Klaster konverzacije',
	'areaChartCaption': 'Površinski grafikon',
	'barChartCaption': 'Trakasti grafikon',
	'columnChartCaption': 'Stupac',
	'stackedbarChartCaption': 'Složena traka',
	'stackedcolumnChartCaption': 'Složeni stupac',
	'bubbleChartCaption': 'Mjehuričasti grafikon',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Analiza pogonitelja',
	'scatterChartCaption': 'Raspršeni grafikon',
	'lineChartCaption': 'Linija',
	'pointChartCaption': 'Točkasti grafikon',
	'heatChartCaption': 'Toplinska mapa',
	'bulletChartCaption': 'Bullet grafikon',
	'waterfallChartCaption': 'Vodopad grafikon',
	'radarChartCaption': 'Radar grafikon',
	'boxplotChartCaption': 'Dijagram pravokutnika',
	'pieChartCaption': 'Tortni grafikon',
	'mapChartCaption': 'Mapa',
	'radialBarChartCaption': 'Radijalni grafikon',
	'compositeChartCaption': 'Linijski i stupčasti grafikon',
	'wordCloudChartCaption': 'Oblak riječi',
	'networkChartCaption': 'Mreža',
	'relationshipNetworkChartCaption': 'Mreža relacija',
	'treemapChartCaption': 'Mapa stabla',
	'packedBubbleChartCaption': 'Pakirani mjehuričasti grafikon',
	'hierarcicalPackedBubbleChartCaption': 'Mjehurić hijerarhije',
	'spiralChartCaption': 'Spiralni grafikon',
	'decisionTreeChartCaption': 'Stablo odlučivanja',
	'legacyMapChartCaption': 'Naslijeđena mapa',
	'sunburstChartCaption': 'Sunburst',
	'visUsageComparison': 'Usporedba',
	'visUsageRelationships': 'Relacije',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Dijelova prema cjelini',
	'visUsageGeospatial': 'Geoprostorni podaci',
	'visUsageAdvanced': 'Napredna analitika',
	'visUsageTablesAndSummary': 'Tablice i sumiranje',
	'visUsageSocialInsights': 'Društveni uvidi',
	'visUsageOther': 'Ostalo',
	'autoBinActionText': 'Auto-grupiranje',
	'filterAutobinActionText': 'Pregradci filtera',
	'memberCalculationActionText': 'Izračun člana',
	'toolbarActionCalculation': 'Kreiraj izračun',
	'toolbarActionEditCalculation': 'Uredi izračun',
	'topBottomRankLabel': 'Rang (%{label})',
	'toolbarDeleteFilterActionText': 'Ukloni filter',
	'toolbarActionTopKeyDrivers': 'Pokaži pogonitelje',
	'toolbarActionCustomGroup': 'Prilagođena grupa',
	'canNotCreateCustomGroup': 'Ne možemo kreirati ovu prilagođenu grupu.',
	'aria_label_datatable': 'Tablica podataka',
	'summaryCaption': 'Sumiranje',
	'MeasuresCaption': 'Mjere',
	'MeasuresGroupCaption': 'Grupa mjera (%{count})',
	'ValuesCaption': 'Vrijednosti',
	'turnInsightsOn': 'Uključi uvid',
	'turnInsightsOff': 'Isključi uvid',
	'decisionRules': 'Pravila',
	'decisionTree': 'Dijagram stabla',
	'decisionSunburst': 'Sunburst stablo',
	'switchToDecisionRules': 'Prebaci na pravila odlučivanja',
	'switchToDecisionTree': 'Prebaci na stablo odlučivanja',
	'data_group_less_then': 'manje od %{rangeTo}',
	'data_group_to': '%{rangeFrom} do < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} i više',
	'nullValueContent': '(nema vrijednost)',
	'sum': 'Zbroj',
	'count': 'Brojač',
	'countdistinct': 'Brojač različitih',
	'avg': 'Prosjek',
	'min': 'Minimum',
	'max': 'Maksimum',
	'automatic': 'Prilagođeno',
	'variance': 'Varijanca',
	'stddev': 'Standardna devijacija',
	'median': 'Medijan',
	'calculated': 'Izračunato',
	'none': 'Nijedan',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Prompt vrijednosti',
	'inputLabelPrompt': 'Vrijednost',
	'inputPlaceholderPrompt': 'Unesite vrijednost',
	'inputInvalidText': 'Pogrešan unos za %{dataType} tip',
	'unSupportedPrompt': 'Nepodržani prompt',
	'missingDataSource': 'Nije se mogao pronaći pravi izvor podataka.',
	'unSupportedPromptType': 'Prompt scenarij trenutno nije podržan.',
	'preAggregateLabel': 'Primijeni prompt vrijednosti iz izvora podataka',
	'postAggregateLabel': 'Primijeni prompt vrijednosti u izvještaju',
	'preAggregateText': 'Raspon koristi vrijednosti iz izvora podataka, ne koristi vrijednosti prikazane u kontrolnoj ploči.',
	'defaultAggregation_count': 'Brojač',
	'defaultAggregation_countdistinct': 'Brojač različitih',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Prosjek',
	'defaultAggregation_sum': 'Zbroj',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Ukupni prosjek',
	'keydriver_up_down': 'Istaknute grupe s visokim ili niskim prosjecima utječu više na cilj. Grupe s neobično visokim ili niskim prosjecima utječu najviše.',
	'keydriver_different': 'Istaknute grupe imaju distribucije koje se znatno razlikuju od ukupne distribucije. Te grupe jače utječu na cilj.',
	'topOperator': 'Vrh',
	'bottomOperator': 'Dno',
	'topBottomFact': '%{operator} %{value}%{percent} po %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Izbriši brojač gornjih ili donjih',
	'deleteTopBottomPercent': 'Izbriši gornji ili donji %',
	'topBottomTitle': 'Samo ovaj objekt',
	'deleteTopBottom': 'Izbriši brojač gornjih ili donjih',
	'editTopBottom': 'Uredi brojač gornjih ili donjih',
	'editTopBottomCount': 'Uredi brojač gornjih ili donjih',
	'editTopBottomPercent': 'Uredi gornji ili donji %',
	'ariaDeleteTopBottomCountLabel': 'Pritisnite tipku DELETE za brisanje brojača gornjih ili donjih.',
	'ariaDeleteTopBottomPercentLabel': 'Pritisnite tipku DELETE za brisanje postotka gornjih ili donjih.',
	'ariaEditTopBottomCountLabel': 'Pritisnite tipku ENTER za uređivanje brojača gornjih ili donjih.',
	'ariaEditTopBottomPercentLabel': 'Pritisnite tipku ENTER za uređivanje postotka gornjih ili donjih.',
	'ariaDeleteDrillStateLabel': 'Pritisnite tipku ENTER za uređivanje brojača gornjih ili donjih.',
	'drillUpStateTitle': 'Buši prema gore',
	'drillDownStateTitle': 'Buši prema dolje',
	'ariaEditTopBottomLabel': 'Pritisnite tipku ENTER za uređivanje brojača gornjih ili donjih.',
	'ariaDeleteTopBottomLabel': 'Pritisnite tipku DELETE za brisanje brojača gornjih ili donjih.',
	'allKeyDriversLabel': 'Automatski (svi pogonitelji)',
	'filter_drag_and_drop_single_dock': 'Povucite i ispustite podatke ovdje za filtriranje.',
	'filter_drag_and_drop_all_tabs': 'Povucite podatke i ispustite ih ovdje za filtriranje svih kartica.',
	'filter_drag_and_drop_current_tab': 'Povucite podatke i ispustite ih ovdje za filtriranje ove kartice.',
	'filter_empty_consume_mode': 'Filteri nisu primijenjeni.',
	'filterClearAllItems': 'Isprazni sve filtere',
	'filterDeleteAllItems': 'Izbriši sve filtere',
	'filterDockChevronLeft': 'Pomiči se kroz podatke',
	'filterDockChevronRight': 'Pomiči se kroz podatke',
	'filterIconLabel_Single': 'Filteri',
	'filterIconLabel_Global': 'Sve kartice',
	'filterIconLabel_Tab': 'Ova kartica',
	'filterIconTooltip_Single': 'Filteri',
	'filterIconTooltip_Global': 'Filteri za sve kartice',
	'filterIconTooltip_Tab': 'Filteri za ovu karticu',
	'filterDropZoneTooltip_Single': 'Filter zone ispuštanja',
	'filterDropZoneTooltip_Global': 'Filter zone ispuštanja za sve kartice',
	'filterDropZoneTooltip_Tab': 'Filter zone ispuštanja za ovu karticu',
	'filterOverflowMenu': 'Više',
	'expand': 'Proširi',
	'collapse': 'Skupi',
	'filterDockItemNameAriaLabel': 'Pritisnite Enter za pokretanje dijaloga filtera i definiranje filtera.',
	'filterItemCanvasMove': 'Dodaj na platno',
	'filterItemDelete': 'Izbriši filter',
	'filterInvertRange': 'sve osim: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Ne poslije %{from}',
	'filter_date_after': 'Poslije %{from}',
	'filter_date_before_except': 'Ne prije %{to}',
	'filter_date_before': 'Prije %{to}',
	'filter_date_between_except': 'Ne između %{from}-%{to}',
	'filter_date_between': 'Između  %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Sve',
	'filter': 'Filter',
	'filterExcept': 'osim %{values}',
	'filterDockToolbarButtonLabel': 'Vezanje filtera',
	'navigateTitle': 'Otiđi do',
	'navigateSelectColumn': 'Izaberite stupac',
	'navigateSelectPath': 'Izaberite navigacijsku stazu',
	'current_nav_group': 'Trenutna navigacijska grupa je %{navigation_group_name}',
	'next': 'Sljedeće',
	'previous': 'Prethodno',
	'multiselectMsg': '%{count} izabrano',
	'errMsgFilterItemMissingTitle': 'Vrijednost(i) filtera %{itemName} ne mogu se učitati jer te vrijednosti nisu dostupne za ovaj skup podataka',
	'errMsgFilterItemGenericTitle': 'Vrijednosti filtera se ne mogu učitati',
	'textFilterItemsNotFound': 'Nema dostupnih stavki.',
	'nullValueLabel': '(prazno)',
	'filterConditionLabel': 'Uvjet filtera',
	'filter_includesAll': 'Uključi sve',
	'filter_allMembersOfSet': 'Svi članovi skupa',
	'modelFilter': 'Filter',
	'filtersTitle': 'Svojstva filtera',
	'search': 'Traži',
	'clearTextFilterValue': 'Isprazni',
	'invertFilterSelection': 'Preokreni',
	'modellingLoading': 'Učitavanje...',
	'searchAll': 'Pronađi sve stupce',
	'toolbarActionPossibleKeyDrivers': 'Uređivanje opsega',
	'toolbarActionPossibleKeyDriversSubTitle': 'Povucite podatke s lijeve strane koji će se uzeti u obzir u grafikonu analize pogonitelja',
	'toolbarActionSort': 'Sortiraj',
	'toolbarActionSortAscending': 'Uzlazno',
	'toolbarActionSortDescending': 'Silazno',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Prilagođeno',
	'toolbarActionFormat': 'Formatiraj podatke',
	'toolbarActionFormatText': 'Formatiraj podatke (tekst)',
	'toolbarActionFormatAbbreviation': 'Skrati',
	'toolbarActionFormatNone': 'Automatski',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Vrh ili dno',
	'toolbarActionRmvShape': 'Ukloni oblik',
	'toolbarActionToggleShapeDrop': 'Oblik infografika',
	'toolbarActionToggleShapeDropTitle': 'Kreiranje infografike',
	'toolbarActionToggleShapeDropText': 'Povucite oblik u ovo polje da kreirate infografiku.',
	'toolbarActionAggregationType': 'Sumiraj',
	'toolbarDeleteActionText': 'Ukloni stupac',
	'toolbarTextActionText': 'Primijeni stil na tekst',
	'toolbarActionFilterLocalKeepSelected': 'Zadrži',
	'toolbarActionFilterLocalExcludeSelected': 'Isključi',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Jednostavni izračun',
	'toolbarActionDrillBack': 'Natrag',
	'toolbarActionDrillUp': 'Buši prema gore',
	'toolbarActionDrillDown': 'Buši prema dolje',
	'toolbarActionJumpTo': 'Buši kroz',
	'toolbarActionNavigate': 'Navigacija',
	'toolbarActionCreateFilterGroup': 'Kreiraj novo povezivanje',
	'toolbarActionDisconnectFilterGroup': 'Prekini sve veze',
	'toolbarActionLinkFilterGroup': 'Dodaj postojećoj vezi',
	'toolbarActionLassoSelect': 'Izbor alata',
	'toolbarActionRefreshDeveloperWidget': 'Osvježi',
	'textFontFamilySubClassHairline': 'Vrlo tanko',
	'textFontFamilySubClassThin': 'Tanko',
	'textFontFamilySubClassThinItalic': 'Tanko kurziv',
	'textFontFamilySubClassExtraLight': 'Vrlo svjetlo',
	'textFontFamilySubClassExtraLightItalic': 'Vrlo svjetlo kurziv',
	'textFontFamilySubClassLight': 'Svjetlo',
	'textFontFamilySubClassLightItalic': 'Svjetlo kurziv',
	'textFontFamilySubClassRegular': 'Redovni',
	'textFontFamilySubClassRegularItalic': 'Redovni kurziv',
	'textFontFamilySubClassItalic': 'Kurziv',
	'textFontFamilySubClassMedium': 'Srednji',
	'textFontFamilySubClassMediumItalic': 'Srednji kurziv',
	'textFontFamilySubClassHeavy': 'Deblje',
	'textFontFamilySubClassHeavyItalic': 'Deblji kurziv',
	'textFontFamilySubClassDemiBold': 'Polu podebljano',
	'textFontFamilySubClassDemiBoldItalic': 'Polu podebljani kurziv',
	'textFontFamilySubClassBold': 'Podebljano',
	'textFontFamilySubClassBoldItalic': 'Podebljani kurziv',
	'textFontFamilySubClassExtraBold': 'Jako podebljano',
	'textFontFamilySubClassExtraBoldItalic': 'Jako podebljani kurziv',
	'textFontFamilySubClassBlack': 'Crna',
	'textFontFamilySubClassBlackItalic': 'Crni kurziv',
	'textFontFamilySubClassStencil': 'Matrica',
	'dlg_ascending': 'uzlazno',
	'dlg_descending': 'silazno',
	'dlg_custom': 'prilagođeno',
	'dlg_none': 'ništa',
	'dlg_hierarchy': 'hijerarhija',
	'dlg_namedSet': 'imenovani skup',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Vizualizacija',
	'chartLabel': '%{chartName} grafikon',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pritisnite F12 za navigaciju unutar grafičkog elementa',
	'f10KeyDescription': 'Pritisnite F10 za pokretanje pogleda s grafičkim elementom u fokusu',
	'playButtonLabel': 'Pokreni',
	'dataPlayerValueListLabel': 'Vrijednosti playera podataka',
	'localFilterTitle': 'Samo ovaj objekt',
	'globalFilterTitle': 'Svi objekti',
	'deleteFilter': 'Izbriši filter',
	'editFilter': 'Uredi filter',
	'ariaEditFilterLabel': 'Pritisnite tipku ENTER za uređivanje filtera.',
	'ariaDeleteFilterLabel': 'Pritisnite tipku DELETE za brisanje filtera.',
	'measureFilterBetween': 'Između %{lowerBound} i %{upperBound}',
	'measureFilterNotBetween': 'Ne između %{lowerBound} i %{upperBound}',
	'dimFilterIn': 'Uključuje: %{in}',
	'dimFilterNotIn': 'Isključuje: %{out}',
	'gtFilter': 'Poslije %{lowerBound}',
	'ltFilter': 'Prije %{upperBound}',
	'ariaEditPrompt': 'Pritisnite tipku ENTER da promijenite prompt vrijednost',
	'dataPointFilterTitle': 'Točke podataka',
	'dataPointFilterIncludeSummary': 'Uključeno %{valueCount} točaka podataka',
	'dataPointFilterExcludeSummary': 'Isključeno %{valueCount} točaka podataka',
	'widgetFiltersLabel': 'Filteri grafičkih elemenata',
	'coachMarkTitleSpiralTarget': 'Uređivanje opsega',
	'coachMarkContentSpiralTarget': 'Ovdje možete dohvatiti i promijeniti izbor pogonitelja za vaš cilj.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Neprepoznate lokacije:',
	'geomapAmbiguousLocations': 'Neodređene regije:',
	'visualizationNotifications': 'Obavijesti vizualizacije:',
	'dataNotifications': 'Obavijesti podataka:',
	'autobinSuggestion': 'Uključi auto-grupiranje',
	'LIVE_empty_visualization_hint_title': 'Izgradite vašu vizualizaciju',
	'LIVE_empty_visualization_hint_description': 'Povucite podatke ovdje ili na polja.',
	'LIVE_slots_required_field_description': '%{asterisk} označava obavezno polje',
	'LIVE_slots_drag_and_drop_description': 'Povucite podatke i ispustite ih na polja iznad da biste izgradili i filtrirali vizualizaciju.',
	'dwErrorLoadingAvailableVisualizations': 'Ne možemo učitati dostupne definicije vizualizacija',
	'moreDataIndicator': 'Vaši podaci su odrezani nakon %{threshold} stavki. Primijenite filter ako želite prikazati manje.',
	'nonCtxTopBottomInvalid': 'Definiranje pravila za gornje ili donje elemente bez konteksta nije podržano za crosstabove. Uklonjeno je iz ovog pogleda crosstaba.  Predefinirajte pravilo na jednoj ili više kategorija uz kontekst %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Ne možemo učitati objekt jer mu nedostaje definicija vizualizacije.',
	'dwErrorLoadingVisualizationListNotFound': 'Ne možemo učitati vizualizaciju.',
	'dwErrorRunningQuery': 'Ne možemo dohvatiti podatke iz skupa podataka %{datasetName}.',
	'dwErrorGeoData': 'Pojavljuju se problemi kod prikaza geografskih podataka u mapi. Molim, izaberite drugi tip vizualizacije.',
	'dwPromptSignonCancelWarning': 'Podaci ove vizualizacije nisu dostupni. Molim, navedite parametre s ispravnim vjerodajnicama.',
	'dwErrorMissingDataset': 'Ne možemo učitati vizualizaciju jer njezin pridruženi skup podataka "%{datasetName}" nije dostupan.',
	'dwErrorRenderingVisualization': 'Ne možemo učitati ovu vizualizaciju.',
	'dwErrorVisualizationTooSmall': 'Vizualizacija je premalena za prikaz podataka koje sadrži. Povećajte vizualizaciju ili ograničite podatke koje sadrži.',
	'errorSourceNotFound': 'Ne možemo učitati vizualizaciju jer njezin pridruženi izvor "%{sourceName}" nije dostupan.',
	'errorActionNotSupported': 'Ova akcija nije podržana za izvor podataka "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'Vizualizacija ima mjere na više rubova, što više nije podržano. Molim postavite mjere samo na jednom rubu.',
	'errorExceedAllowableValue': 'Procijenjeni broj ćelija premašuje dozvoljeni broj od 100 000. Molim, primijenite filtriranje na projicirane skupove kako biste smanjili broj ćelija.',
	'propScaleLabel': 'Količina ikona',
	'propScaleDescription': 'Izaberite broj ikona',
	'propScaleFew': 'Nizak',
	'propScaleDefault': 'Default',
	'propScaleMany': 'Visok',
	'lastRefresh': 'Zadnje osvježavanje: prije %{timeInterval}',
	'widgetTimer': 'Timer grafičkog elementa',
	'datasetItemsUnavailable': 'Neki podaci skupa podataka koji se koriste u ovoj vizualizaciji nisu dostupni.',
	'datasetItemUnavailable': 'Ovaj podatak skupa podataka nije dostupan',
	'retry': 'Pokušaj ponovno',
	'widgetConditionalFormatLabel': 'Prebacivanje kontrola uvjetnog formatiranja',
	'widgetConditionalFormatTitle': 'Uređivanje boje uvjetnog formatiranja',
	'crosstabName': 'Crosstab',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Nije dostupno',
	'summaryLabel': '%{label} s vrijednosti %{value}',
	'infographicLabel': '%{label} s vrijednosti %{value}',
	'warning': 'Upozorenje',
	'swapRowsAndColumns': 'Zamjena redova i stupaca',
	'hideSummariesLabel': 'Sakrij sumiranja',
	'showSummariesLabel': 'Pokaži zbrojeve',
	'hideRowColumn': 'Sakrij',
	'showAllRowColumn': 'Pokaži sve',
	'dataAssetPropertiesLabel': 'Svojstva vizualizacije',
	'evAdd': 'Dodaj stupac',
	'evCollapse': 'Skupi',
	'evColumns': 'Stupci',
	'evLocalFilters': 'Lokalni filteri',
	'evExpand': 'Proširi',
	'evFilterTooltip': 'Filter',
	'missingColumn': 'Nedostaje: %{columnLabel}',
	'missingFiltering': 'Nedostaju filteri na stupcima:',
	'missingDataItem': 'Referencirani podatak "%{dataItemId}" nije nađen u grafičkom elementu.',
	'heatByLabel': 'Toplinski po',
	'toolbarChangeVisualization': 'Promijeni vizualizaciju',
	'modellingRelatedTablesNoneFound': 'Nisu pronađene povezane tablice',
	'processing': 'Obrada...',
	'errorCellWarning': 'Neke vrijednosti sumiranja se nisu mogle izračunati.',
	'aggregateTypeToggler': 'Pokaži tip agregacije',
	'maxColumnsExceeded': 'Premašen je maksimalni broj stupaca. %{columns} ispušten(o).',
	'unboundColumns': 'Sljedeći stupci se ne mogu koristiti: %{columns}.',
	'unboundColumn': 'Ne može se koristiti sljedeći stupac: %{columns}.',
	'recommendRequestFailed': 'Zahtjev za preporuku nije uspio. Molim kontaktirajte vašeg administratora.',
	'visualizationDoesNotSupportOLAP': 'Ne možemo kreirati ovu vizualizaciju koja je bazirana na OLAP izvoru podataka. Molim, koristite drugi podržani izvor podataka.',
	'showDataBehindVizLabel': 'Pokaži podatke',
	'showDataBehindVizNotSupportedLabel': 'Pokaži podatke nije podržano za ovaj tip vizualizacije',
	'exploreData': 'Istraži ...',
	'newExplore': 'Novo istraživanje',
	'thumbnails_error_fetching': 'Greška kod dohvata sličica',
	'loadedThumbnailImage': 'Učitana sličica %{visType} vizualizacije',
	'autobinAxisLabel': 'grupe',
	'recommended_visualizations': 'Preporučene vizualizacije',
	'all_visualizations': 'Sve vizualizacije',
	'edit': 'Uredi',
	'selectTargetDialogTitle': 'Izaberite cilj za bušenje kroz',
	'noTargetInCM': 'Ne može se pronaći cilj bušenja kroz',
	'errorDrillDefinition': 'Nešto je krenulo krivo dok ste dodavali ili uređivali definiciju bušenja kroz.',
	'errorDrillToTarget': 'Pojavila se greška kod bušenja prema "%{targetName}"',
	'drillThroughMappingViewLabel': 'Dodijeli stupce iz kontrolne ploče promptovima ciljnog izvještaja',
	'drillthroughScopeRadioLabel': 'Primijeni ovu definiciju na:',
	'drillthroughScopeRadioOptionVisualization': 'Samo ovu vizualizacija',
	'drillthroughScopeRadioOptionConnection': 'Vizualizacije u istoj vezi koje koriste isti izvor podataka',
	'drillthroughScopeRadioOptionDashboard': 'Bilo koju vizualizaciju na %{perspective} koja koristi isti izvor podataka',
	'drillThroughParametersColumnTitle': '"%{targetName}" promptovi:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" stupci podataka:',
	'drillThroughDefinitionNoParameter': 'Cilj bušenja kroz nema promptova.',
	'drillThroughDefinitionErrorQueryingReport': 'Ispravite problem u ciljnom izvještaju i zatim pokušajte ponovno kreirati definiciju bušenja kroz.',
	'drillThroughDefinitionErrorDlgTitle': 'Nešto je krenulo krivo',
	'dlg_back': 'Idi natrag',
	'dlg_close': 'Zatvori',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Opoziv',
	'dlg_apply': 'Primijeni',
	'dlg_create': 'Kreiraj',
	'dlg_done': 'Gotovo',
	'drillthrough_unsaveMsg': 'Nastaviti bez spremanja "%{name}"?',
	'drillthrough_jumpTo': 'Definicija bušenja kroz: %{name}',
	'drillthrough_jumpToLabel': 'Bušenje kroz',
	'drillthrough_manage': 'Upravljanje...',
	'drillthrough_addNewTarget': 'Dodaj novu definiciju bušenja kroz',
	'drillthrough_manageJumpPaths': 'Upravljanje definicijama bušenja kroz',
	'drillthrough_manageJumpPaths_edit': 'Uredi "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Izbriši "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Dodaj drugu definiciju bušenja kroz',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Potvrda brisanja',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Jeste li sigurni da želite izbrisati bušenje kroz "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Dupliciraj naziv bušenja kroz',
	'drillthrough_definitionMessage': 'Bušenje kroz "%{name}" već postoji. Navedite različiti naziv',
	'drillthrough_jumpToTarget_notFound': 'Cilj nije nađen za bušenje kroz "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'Ciljnom izvještaju neće biti predan kontekst.',
	'drillthrough_titleLabel': 'Naziv',
	'drillthrough_create_dialogTitle': 'Kreiraj definiciju bušenja kroz',
	'drillthrough_edit_dialogTitle': 'Uredi definiciju bušenja kroz',
	'drillthrough_subTitle': 'Kontekst vizualizacije u izvoru koristi se za filtriranje cilja %{perspective}.',
	'drillthrough_selectColumn': 'Izaberite stupac',
	'noPrompt': 'Nema promptova',
	'promptDialog': 'Dijalog za %{promptType} prompt',
	'formatAutoDescription': 'Auto specificira format koji se nasljeđuje od izvora podataka ili vizualizacije.',
	'formatDefaultDescription': 'Default specificira format naslijeđen iz sistema',
	'createCustomGroupAction': 'Kreiraj grupu podataka',
	'removeCustomGroupAction': 'Ukloni grupu podataka',
	'editCustomGroupAction': 'Uredi grupu podataka',
	'renameCustomGroupAction': 'Preimenuj grupu podataka',
	'createCustomGroupErrorToast': 'Vaša grupa podataka nije se mogla kreirati.',
	'removeCustomGroupErrorToast': 'Vaša grupa podataka nije se mogla ukloniti.',
	'editCustomGroupErrorToast': 'Vaša grupa podataka nije se mogla urediti.',
	'renameCustomGroupErrorToast': 'Vaša grupa podataka nije se mogla preimenovati.',
	'customGroupLabel': 'Kreiraj grupu podataka',
	'ungroupCustomGroupLabel': 'Poništi grupiranje',
	'renameCustomGroupLabel': 'Preimenuj',
	'createCustomGroupLabel': 'Kreiraj',
	'customGroupingLabel': '%{columnLabel} (grupa)',
	'createCustomSort': 'Kreiraj prilagođeno sortiranje',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Izaberite dostupne stavke, a zatim ih poredajte da kreirate prilagođeno sortiranje.',
	'availableItems': 'Dostupne stavke',
	'selectAll': 'Izaberi sve',
	'customSortOrder': 'Prilagođeni redoslijed sortiranja',
	'selectAvailableItemsDesc': 'Izaberite dostupne stavke, a zatim ih poredajte ovdje.',
	'moveToTop': 'Premjesti na vrh',
	'clear': 'Isprazni',
	'sortRemainingItemsBy': 'Sortiraj preostale stavke po',
	'removeAll': 'Ukloni sve',
	'resetTooltip': 'Sve stavke bit će uklonjene iz %{customSortOrder} liste. Padajuća lista %{sortRemainingItemsBy} bit će vraćena na defaultne vrijednosti.',
	'manyItemsWarning': 'Biranje velikog broja stavki može utjecati na performanse vaše kontrolne ploče.',
	'manyItemsSelected': 'Izabrano je više od %{maxItems} stavki što može utjecati na performanse vaše kontrolne ploče.',
	'somethingWentWrong': 'Oh ne. Nešto nije u redu.',
	'tryAgain': 'Pokušaj ponovno',
	'customSortLabel': 'Prilagođeno sortiranje',
	'applyError': 'Ne može se primijeniti %{action}.',
	'searchReturnedNoResults': 'Hm, vaše pretraživanje nije vratilo nijedan rezultat.',
	'extVisSystem': 'Sistem',
	'extVisCustom': 'Prilagođeno',
	'customVisTestVisualization': 'Testiraj vizualizaciju',
	'extVisCustomVisPreview': 'pregled',
	'extVisCustomPreviewWidgets': 'Grafički elementi za razvoj',
	'extVisCustomVVisualization': 'Vizualizacija',
	'extVisCustomVisuals': 'Prilagođene vizualizacije',
	'noPermissionToManage': 'Nemate dozvolu za upravljanje prilagođenim vizualizacijama.',
	'extVisCustomUpdate': 'Ažuriraj',
	'extVisCustomDelete': 'Izbriši',
	'extVisNoCustomVisuals': 'Nema prilagođenih vizualizacija',
	'extVisNoCustomVisualsMsg': 'Trenutno ne postoje prilagođene vizualizacije u vašoj organizaciji',
	'extVisAddCustomVisual': 'Dodaj prilagođenu vizualizaciju',
	'extVisNoCustomVisualsAdminMsg': 'Trenutno nema prilagođenih vizualizacija. Dodajte jednu za početak.',
	'extVisNoSDKConnection': 'Veza nije kreirana za vašu lokalnu datoteku',
	'extVisNoSDKPreviewMsg': 'Da biste vidjeli svoje vizualizacije, molim uspostavite vezu.',
	'extVisMore': 'Više',
	'extVisDeleteDialogTitle': 'Izbriši prilagođenu vizualizaciju',
	'extVisDeleteDialogBody': 'Jeste li sigurni da želite izbrisati ovu prilagođenu vizualizaciju? Možda ju koriste druge  kontrolne ploče i izvještaji.',
	'extVisDeleteConfirmation': 'Vaša prilagođena vizualizacija je izbrisana.',
	'extVisDeleteError': 'Vaša prilagođena vizualizacija nije se mogla izbrisati. %{msg}',
	'extVisCloseToast': 'Zatvori sad',
	'extVisAdd': 'Vaša prilagođena vizualizacija uspješno je dodana.',
	'extVisAddError': 'Vaša prilagođena vizualizacija nije se mogla dodati. %{msg}',
	'extVisUpdate': 'Vaša prilagođena vizualizacija uspješno je ažurirana.',
	'extVisUpdateError': 'Vaša prilagođena vizualizacija nije se mogla ažurirati. %{msg}',
	'extVisAddProgress': 'Importiranje %{name}',
	'extVisUpdateProgress': 'Ažuriranje %{name}',
	'extPermissionTitle': 'Ograničeni pristup ili izbrisana prilagođena vizualizacija',
	'extPermissionBody': 'Ova prilagođena vizualizacija ne može se pogledati zato što je ili izbrisana ili je ograničen pristup vizualizaciji.',
	'customVizSaveWarning': 'Vaše prilagođene vizualizacije ne mogu se spremiti. Nisu importirane.',
	'schematicTestCaption': 'Testiraj shemu',
	'schematicServiceRequestError': 'Greška servisa sheme',
	'extVisPreviewMessage': 'Ovo je pregled. Vizualizacija još nije dodana proizvodu.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Nedefinirano',
	'kpiDefaultTargetLabel': 'Cilj',
	'kpiNonNumericTarget': 'Ciljna vrijednost mora biti broj.',
	'kpiManualTargetSlotFilled': 'Vrijednost primijenjena u polju',
	'kpiAutoValueSize': 'Automatski',
	'kpiUnableDrawSparklineLabel': 'Ne može se nacrtati sparkline grafikon.',
	'kpiUnableDrawSparklineInfo': 'Sparkline grafikon zahtijeva najmanje dvije točke u vremenu. Promijenite podatke ili podesite filtere da biste vidjeli sparkline.',
	'conditionalFormattingTextColor': 'Boja teksta',
	'suppression': 'Potiskivanje',
	'suppressNone': 'Nijedan',
	'suppressRowsAndColumns': 'Stupci i redovi',
	'suppressRows': 'Redovi',
	'suppressColumns': 'Stupci',
	'enableSuppression': 'Omogući potiskivanje',
	'disableSuppression': 'Onemogući potiskivanje',
	'loadVisDefinitionError': 'Ne može se učitati definicija za vizualizaciju %{id}',
	'emptyVisualization': 'Prazna vizualizacija',
	'expandCollapse': 'Proširi i skupi',
	'expandBtnLabel': 'Proširi',
	'collapseBtnLabel': 'Skupi',
	'prop_sizeInputNonNumericValue': 'Vrijednost mora biti broj.',
	'prop_sizeValueShouldBeHigher': 'Vrijednost mora biti veća od %{value}.',
	'fontPropLabel': 'Obitelj fontova',
	'fontSizePropLabel': 'Veličina fonta',
	'sectionItemAxisTitle': 'Naslov osi podatka',
	'sectionItemAxisLabel': 'Oznaka osi podatka',
	'sectionValueAxisTitle': 'Naslov osi vrijednosti',
	'sectionValueAxisLabel': 'Oznaka osi vrijednosti',
	'styletext-widget.legend': 'Legenda',
	'styletext-itemAxis.ticks.labels': 'Oznake osi',
	'styletext-valueAxis.title': 'Naslovi osi',
	'styletext-itemAxis.title': 'Naslovi osi',
	'styletext-labels': 'Oznake podataka',
	'styletext-valueAxis.line.title': 'Naslovi linija',
	'styletext-cellValue': 'Vrijednosti',
	'styletext-values': 'Vrijednosti',
	'styletext-rowHeading': 'Zaglavlja redova',
	'styletext-columnHeading': 'Zaglavlja stupaca',
	'fontFamily': 'obitelj',
	'fontSize': 'veličina',
	'visExportFileName': 'Vizualizacija',
	'ds-missingDataSet': 'Nije se mogao pronaći dataset. Molim, provjerite da li je dataset uspješno kreiran.',
	'ds-missingDashboardId': 'Molim, spremite kontrolnu ploču prije kreiranja dataseta.',
	'ds-unsupportedDataSourceType': 'Tip %{type} izvora podataka nije podržan.',
	'dataCache': 'Predmemorija podataka',
	'dataCache_on': 'Uključeno',
	'dataCache_off': 'Bez predmemorije',
	'dataCache_auto': 'Automatski',
	'queryOptimization': 'Optimizacija upita'
});
